import { render, staticRenderFns } from "./penalty-functions.vue?vue&type=template&id=5b98dea0&scoped=true"
import script from "./penalty-functions.vue?vue&type=script&lang=js"
export * from "./penalty-functions.vue?vue&type=script&lang=js"
import style0 from "./penalty-functions.vue?vue&type=style&index=0&id=5b98dea0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98dea0",
  null
  
)

export default component.exports